import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getPatientAudios () {
    return Api().get("/patient-audio");
  },
  updatePatientAudio (params) {
    return Api().put("/patient-audios",params);
  },
  addPatientAudio (params) {
    return Api().post("/patient-audios",params);
  },
  getPatientAudio (params) {
    return Api().get("/patient-audios/"+params);
  },
  getPatientAudioByPatient (params) {
    return Api().get("/patient-audios-by-patient/"+params);
  },
  deletePatientAudio (params) {
    return Api().delete("/patient-audios/"+params);
  },
  getPatientAudioByRouteSheets(params){
    return Api().get("/patient-audios-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientAudioService.js